export const CATEGORIES = [
  {
    id: "gouvernance",
    name: "Gouvernance",
    desc: "Décision, redevabilité et pilotage des projets et des organisations.",
    items: [
      { ref: "N° 01", type: "Note de réflexion", date: "À paraître", t: "La gouvernance comme condition de la performance durable des projets", d: "Pourquoi la qualité des dispositifs de décision détermine la réussite des projets complexes." },
    ],
  },
  {
    id: "ppp-infrastructures",
    name: "PPP & Infrastructures",
    desc: "Structuration, financement et partenariats public-privé.",
    items: [
      { ref: "N° 02", type: "Note de réflexion", date: "À paraître", t: "Structurer avant de financer : la maturité des projets comme condition de leur réussite", d: "Le rôle déterminant de la structuration amont dans la réussite des projets d'infrastructures." },
      { ref: "N° 03", type: "Étude sectorielle", date: "À paraître", t: "Gouvernance des partenariats public-privé : équilibre, transparence et durabilité", d: "Les conditions d'un PPP soutenable, aligné sur l'intérêt public de long terme." },
    ],
  },
  {
    id: "transition-energetique",
    name: "Transition Énergétique",
    desc: "Décarbonation, nouvelles filières et infrastructures énergétiques.",
    items: [
      { ref: "N° 04", type: "Tribune", date: "À paraître", t: "Transition énergétique en Afrique : concilier ambition, réalité et financement", d: "Comment articuler trajectoire bas-carbone, développement et modèles économiques viables." },
    ],
  },
  {
    id: "impact",
    name: "Impact",
    desc: "Mesure de la valeur créée, performance et redevabilité.",
    items: [
      { ref: "N° 05", type: "Note de réflexion", date: "À paraître", t: "Mesurer l'impact : au-delà de la livraison, la valeur durable", d: "Concevoir des cadres d'évaluation qui rendent visible la valeur économique, sociale et environnementale." },
    ],
  },
  {
    id: "secteur-public-bailleurs",
    name: "Secteur public & Bailleurs",
    desc: "Institutions publiques, autorités contractantes et bailleurs de fonds.",
    items: [
      { ref: "N° 06", type: "Décryptage", date: "À paraître", t: "Renforcer les capacités publiques à concevoir et piloter des projets d'envergure", d: "Le rôle des institutions et des bailleurs dans la qualité et la robustesse des projets financés." },
    ],
  },
];
